/**
 * Reads the root /Pages /Count from a PDF byte stream.
 * Falls back to counting /Type /Page objects when the catalog is not parseable.
 */
export function getPdfPageCountFromBytes(bytes: Uint8Array): number | null {
  const text = new TextDecoder("latin1").decode(bytes);

  const pagesDictionaryCount = getPagesDictionaryCount(text);
  if (pagesDictionaryCount > 0) {
    return pagesDictionaryCount;
  }

  const pageObjects = text.match(/\/Type\s*\/Page(?!s)/g);
  if (pageObjects?.length) {
    return pageObjects.length;
  }

  return null;
}

function getPagesDictionaryCount(pdfText: string): number {
  const pagesDictionaryMatches = [
    ...pdfText.matchAll(
      /<<[\s\S]*?\/Type\s*\/Pages[\s\S]*?\/Count\s+(\d+)[\s\S]*?>>/g
    ),
  ];

  if (pagesDictionaryMatches.length === 0) {
    return 0;
  }

  return Math.max(
    ...pagesDictionaryMatches.map((match) => parseInt(match[1], 10))
  );
}

export async function fetchPdfPageCount(url: string): Promise<number | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return null;
    }

    const bytes = new Uint8Array(await response.arrayBuffer());
    return getPdfPageCountFromBytes(bytes);
  } catch {
    return null;
  }
}

export function getReportAttachmentPdfHeight(
  width: number,
  pageCount: number
): number {
  if (width <= 0 || pageCount <= 0) {
    return 0;
  }

  const pageHeight = width * (11 / 8.5);
  return pageHeight * pageCount;
}
